import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";

import { useMemo } from "react";
import { DARK_BLUE_COLOR } from "theme/variable";
// import { LIGHT_GARY_COLOR_TRASN } from "theme/variable";

const useOptions = () => {
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize: "15px",
          color: DARK_BLUE_COLOR,
          fontWeight: 500,
        },
        "&::placeholder": {
          color: "red",
          fontSize: 15,
          fontWeight: 500,
        },
      },
    }),
    []
  );
  return options;
};
export function CardNumber(props) {
  return <CardNumberElement options={useOptions()} {...props} />;
}

export function CardExpiry(props) {
  return <CardExpiryElement options={useOptions()} {...props} />;
}
export function CardCvc(props) {
  return <CardCvcElement options={useOptions()} {...props} />;
}
